
namespace RioERP.Shipping {

    @Serenity.Decorators.registerClass()
    export class ShippingProvidersDialog extends Serenity.EntityDialog<ShippingProvidersRow, any> {
        protected getFormKey() { return ShippingProvidersForm.formKey; }
        protected getIdProperty() { return ShippingProvidersRow.idProperty; }
        protected getLocalTextPrefix() { return ShippingProvidersRow.localTextPrefix; }
        protected getNameProperty() { return ShippingProvidersRow.nameProperty; }
        protected getService() { return ShippingProvidersService.baseUrl; }
        protected getDeletePermission() { return ShippingProvidersRow.deletePermission; }
        protected getInsertPermission() { return ShippingProvidersRow.insertPermission; }
        protected getUpdatePermission() { return ShippingProvidersRow.updatePermission; }

        protected form = new ShippingProvidersForm(this.idPrefix);

    }
}